import { useEffect, useState } from 'react'
// Day and night for the whole site, as the iPhone and iPad app do it: follow
// the computer's appearance until the learner chooses with a moon/sun button
// (Home, a lesson, Special Mode, Flashcards — one choice for all of them,
// under the old 'lessonTheme' key so nobody's choice is lost).
//
// The choice is also set on <html data-frost="light|dark">, which is what the
// dialogs and the shared palette (frost.css) read.
const THEME_KEY = 'lessonTheme'

export const systemTheme = () =>
  (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark')

export const chosenTheme = () => {
  try { const t = localStorage.getItem(THEME_KEY); return t === 'light' || t === 'dark' ? t : null } catch { return null }
}

export const readTheme = () => chosenTheme() || systemTheme()

export const applyTheme = (theme = readTheme()) => {
  if (typeof document !== 'undefined') document.documentElement.dataset.frost = theme
}

/** A moon/sun button was pressed: remember it, everywhere. */
export const saveTheme = (theme) => {
  try { localStorage.setItem(THEME_KEY, theme) } catch { /* private mode */ }
  applyTheme(theme)
  try { window.dispatchEvent(new CustomEvent('frost-theme', { detail: theme })) } catch { /* old browser */ }
}

// On load, and whenever the computer switches (if nothing was chosen).
applyTheme()
if (typeof window !== 'undefined' && window.matchMedia) {
  const mq = window.matchMedia('(prefers-color-scheme: light)')
  mq.addEventListener?.('change', () => { if (!chosenTheme()) { applyTheme(); window.dispatchEvent(new CustomEvent('frost-theme', { detail: readTheme() })) } })
}

/** [theme, toggle] for a page with its own moon/sun button. */
export function useFrostTheme() {
  const [theme, setTheme] = useState(readTheme)
  useEffect(() => {
    const follow = (e) => setTheme(e.detail || readTheme())
    window.addEventListener('frost-theme', follow)
    return () => window.removeEventListener('frost-theme', follow)
  }, [])
  const toggle = () => { const next = theme === 'dark' ? 'light' : 'dark'; saveTheme(next); setTheme(next) }
  return [theme, toggle]
}
